import PropTypes from 'prop-types';
import {query} from 'api';
import {Link as RouterLink} from 'react-router-dom';
import {Container, BorderContainer, Title, Small} from './styles';

const PointsBlock = ({data}) => {
  if (!data) return null;
  const {points, points_expiration} = data;

  return (
    <Container>
      <BorderContainer>
        <Small>{`Valables jusqu’au ${points_expiration}`}</Small>
        <Title>
          Vous avez actuellement <br /> {points} points
        </Title>
        <RouterLink
          to="/gifts/more-points"
          style={{fontSize: 14, color: '#B8860B', textDecoration: 'underline'}}>
          Comment obtenir plus de points ?
        </RouterLink>
      </BorderContainer>
    </Container>
  );
};

PointsBlock.propTypes = {
  data: PropTypes.object,
};

export default PointsBlock |> query('getProfile');
